var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({staticClass:"mb-2 mr-2",attrs:{"color":"primary","small":"","fab":"","loading":_vm.pdfWorking,"disabled":_vm.pdfWorking},on:{"click":function($event){return _vm.onBuildClick(
            _vm.title,
            _vm.subtitle,
            _vm.content,
            _vm.headers,
            _vm.filename
        )}}},on),[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mdi-file-pdf-box")])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.$t('system.labels.exportToPdf')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }